module.exports = __webpack_public_path__ + "img/rooster.2122e8f3.gif";